/** @format */
import { css } from 'styled-components';

import { StyledAddToBasketButtonProps } from './index';
import { getBasketPlusTransform } from './style-helpers';

const baseStyles = ({
    isInBasket,
    activeMarket,
}: StyledAddToBasketButtonProps) => {
    const inBasketAnimationDuration = '2s';

    return css`
        @keyframes checkmarkSlideInOut {
            0% {
                opacity: 0;
                transform: translateY(50%);
            }
            10% {
                opacity: 1;
                transform: translateY(0);
            }
            20% {
                opacity: 1;
                transform: translateY(0);
            }
            30% {
                opacity: 0;
            }
            100% {
                opacity: 0;
            }
        }

        @keyframes basketCheckmarkSlideIn {
            0% {
                opacity: 0;
            }
            30% {
                opacity: 0;
                transform: translateX(-100%);
            }
            40% {
                opacity: 1;
                transform: translateX(0);
            }
            70% {
                opacity: 1;
                transform: translateX(0);
            }
            100% {
                &:hover {
                    opacity: 0;
                }
            }
        }

        @keyframes minusFadeIn {
            0% {
                opacity: 0;
            }
            70% {
                opacity: 0;
            }
            100% {
                opacity: 1;
            }
        }

        cursor: pointer;
        padding: 0.4rem;
        margin: -0.4rem;
        border-radius: 1000px;
        overflow: hidden;

        .icon {
            svg {
                position: absolute;
                transition-property: all;
                transition-duration: var(--animations-default-duration);
                transition-timing-function: var(
                    --animations-default-timing-function
                );
            }
        }

        .checkmark {
            animation: ${inBasketAnimationDuration} ease-out 0s 1
                checkmarkSlideInOut forwards;
        }

        .basket-checkmark {
            opacity: 0;
            fill-rule: evenodd;
            animation: ${inBasketAnimationDuration}
                cubic-bezier(0.175, 0.885, 0.32, 1.275) 0s 1
                basketCheckmarkSlideIn;

            ${isInBasket &&
            css`
                opacity: 1;
            `}
        }

        .minus {
            opacity: 0;
            transform: rotate(-90deg) scale(0.5);
            transition-duration: 400ms;
            transition-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1.275);
            animation: ${inBasketAnimationDuration} ease-out 0s 1 minusFadeIn;
        }

        .plus {
            ${getBasketPlusTransform(activeMarket)}
            opacity: 0;
        }

        .basket {
            opacity: 1;

            ${isInBasket &&
            css`
                opacity: 0;
            `}
        }

        .basket-plus {
            ${getBasketPlusTransform(activeMarket)}
            fill-rule: evenodd;
            background-color: var(--colors-surface-primary);
            border-radius: 1000px;

            ${isInBasket &&
            css`
                opacity: 0;
            `}
        }

        &:active {
            .basket-plus {
                transform: scale(1) translate(0, 0);
            }
        }

        @media (hover: hover) and (pointer: fine) {
            &:hover {
                ${isInBasket
                    ? css`
                          .minus {
                              opacity: 1;
                              transform: rotate(0) scale(1);
                          }
                      `
                    : css`
                          .plus {
                              opacity: 1;
                              transform: scale(1) translate(0, 0);
                          }
                      `}

                .basket,
                .basket-checkmark {
                    opacity: 0;
                }

                .basket-plus {
                    opacity: 0;
                    background-color: transparent;
                    transform: scale(1) translate(0, 0);
                }
            }
        }
    `;
};

export const styles = (props: StyledAddToBasketButtonProps) => css`
    ${baseStyles(props)}
`;
